import { fetch } from '../../utils/dataAccess';

export function error(error) {
  return { type: 'PAYMENT_METHODS_LIST_ERROR', error };
}

export function loading(loading) {
  return { type: 'PAYMENT_METHODS_LIST_LOADING', loading };
}

export function success(retrieved) {
  return { type: 'PAYMENT_METHODS_LIST_SUCCESS', retrieved };
}

export function list(page = 'payments/available_payment_method') {
  return dispatch => {
    dispatch(loading(true));
    dispatch(error(''));

    fetch(page)
      .then(response =>
        response
          .json()
          .then(retrieved => {
            dispatch(loading(false));
            dispatch(success(retrieved.data));    
          })
      )
      .catch(e => {
        dispatch(loading(false));
        dispatch(error(e.message));
      });
  };
}

